<template>
  <div class="home_wrap">
    <van-nav-bar :title="$t('报告')" left-text="" left-arrow :fixed="true" @click-left="onClickLeft" />
    <van-tabs v-model="nav_active" :background="'transparent'" shrink class="tabs_box" :line-height="2" :line-width="30"
      @change="tabChange">
      <van-tab title="">
        <template #title>
          <div class="nav_title">
            <span class="ppl">{{ $t("账户") }}</span>
          </div>
        </template>
        <model1 />
      </van-tab>
      <van-tab title="">
        <template #title>
          <div class="nav_title">
            <span class="ppl">{{ $t("投注") }}</span>
          </div>
        </template>
        <model2 />
      </van-tab>
      <van-tab title="">
        <template #title>
          <div class="nav_title">
            <span class="ppl">{{ $t("报告") }}</span>
          </div>
        </template>
        <model3 />
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
import Vue from "vue";
import { Tabs, Tab, NavBar } from "vant";
import Fetch from "../../utils/fetch";
import model1 from "./modules/model1.vue";
import model2 from "./modules/model2.vue";
import model3 from "./modules/model3.vue";
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(NavBar);
export default {
  name: "Record",
  components: {
    model1,
    model2,
    model3,
  },
  data() {
    return {
      nav_active: 0,
    };
  },
  created() {
    console.log(this.$route.query, "传参");
    if (this.$route.query.tab) {
      this.nav_active = +this.$route.query.tab;
      this.tabChange(this.nav_active);
    } else {
      this.tabChange(this.nav_active);
    }
  },
  mounted() { },
  methods: {
    tabChange(v) {
      this.nav_active = v;
    },
    onClickLeft() {
      this.$router.go(-1)
    }
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/variables.less";

/deep/ .van-nav-bar {
  background: @secondary-color;
}

/deep/ .van-nav-bar .van-icon {
  color: #fff;
}

/deep/ .van-nav-bar__title {
  color: #fff;
}

/deep/ .van-tab {
  height: 37px;
}

.home_wrap {
  width: 100%;
  min-height: 100vh;
  //background-color: rgb(48, 48, 48);
  padding-bottom: 1.8rem;
  // padding-top: 1.5rem;
  display: flex;
  flex-direction: column;
}

/deep/ .van-tabs__wrap {
  width: 60%;
  height: 37px;
  // border-bottom: 0.01rem solid @bodercolor;
  background-color: @secondary-color;
}

/deep/ .nav_title span {
  color: @textcolorf;
  font-size: 10px;
}

/deep/ .van-tab--active {
  .nav_title span {
    color: @textcolor1;
  }
}

/deep/ .van-tabs__line {
  background-color: @textcolor1 !important;
}

/deep/ .van-tab__pane {
  height: 100%;
}

.tabs_box {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  /deep/ .van-tabs__content {
    flex: 1;
    height: 90%;
    background-color: @activityColor;
  }
}

.home_wrap {
  width: 100%;
  height: 100vh;
  //background-color: rgb(48, 48, 48);
  padding-bottom: 0;
  padding-top: 1.2rem;
  box-sizing: border-box;
}
</style>